import React, { useContext, useEffect, useRef, useState } from 'react'
import { GetPujaCatLookupList, GetPujaLookupList } from '../../ApiServices/Puja/PujaApi';
import { useLocation, useNavigate } from 'react-router-dom';
import { LoaderContext } from '../../AuthContext/AuthContext';
import NoResultFoundModel from '../../Components/NoDataFound/NoDataFoundModal';
import pandit from "../../assets/images/new/fav-removebg-preview.png";
import HoroscopeBannerImg from "../../assets/images/new/banner-remid.jpeg";
import { t } from 'i18next';
import Breadcrumbs from '../../Components/Breadcrumb';
import { Helmet } from "react-helmet-async";

const PanditPujaListPage = () => {
    const scrollRefs = useRef({});
    const navigate = useNavigate()
    const location = useLocation()
    const user_id = localStorage.getItem("userID");

    const [totalRecords, setTotalRecords] = useState(-1);
    const { setLoader, selectedLanguageID, pujaStatus, setPujaStatus, formatToIndianCurrency } = useContext(LoaderContext);

    const [isOnlineSelected, setIsOnlineSelected] = useState(false);
    const [pujaList, setPujaList] = useState([]);
    const [categories, setCategories] = useState([])

    const [selectedCategory, setSelectedCategory] = useState(null)
    const [isCatUpdated, setIsCatUpdated] = useState(false)
    const [metaDesc, setMetaDesc] = useState("Book trusted pandits for all Hindu ceremonies and pujas. Choose experienced priests for your ritual needs anywhere in India with easy online scheduling.");
    const [metaTitle, setMetaTitle] = useState("Book Expert Pandit Online for Daily Puja | Myomnamo");

    localStorage.setItem("previousPath", location.pathname);

    useEffect(() => {
        GetCatLookupListData(3, 5)
        if (pujaStatus) {
            setIsOnlineSelected(true)
        } else {
            setIsOnlineSelected(false)
        }
    }, [])

    useEffect(() => {
        GetCatLookupListData(3, 5)
    }, [selectedLanguageID])


    // Reset Selected Cat 
    useEffect(() => {

        if (isCatUpdated) {

            const storedCatId = sessionStorage.getItem("selectedCatId");
            if (storedCatId !== null && storedCatId !== undefined && storedCatId !== "") {
                setSelectedCategory(categories[0].pujaCatKeyID)
                GetPujaLookupListData(3, 5, categories[0].pujaCatKeyID)
            } else {
                setSelectedCategory(categories[0].pujaCatKeyID)
                GetPujaLookupListData(3, 5, categories[0].pujaCatKeyID)
            }

            setIsCatUpdated(false)
        }
    }, [isCatUpdated])

    // -------------------API Calling----------------
    const GetCatLookupListData = async (pujaServiceID, pujaSubServiceID) => {

        setLoader(true);
        try {
            const response = await GetPujaCatLookupList({
                applangID: (selectedLanguageID),
                pujaServiceID: pujaServiceID,
                pujaSubServiceID: pujaSubServiceID
            });

            if (response?.statusCode === 200) {
                setLoader(false);
                const list = response?.responseData?.data || []
                setCategories(list);
                setIsCatUpdated(true)

                // setTotalRecords(list?.length);
            }
        } catch (error) {
            setLoader(false);
            console.log(error);
        }
    };

    const GetPujaLookupListData = async (pujaServiceID, pujaSubServiceID, selectedCategory) => {

        setLoader(true);
        try {
            const response = await GetPujaLookupList({
                applangID: (selectedLanguageID),
                pujaServiceID: pujaServiceID,
                pujaSubServiceID: pujaSubServiceID,
                pujaCatKeyID: selectedCategory
            });

            if (response?.statusCode === 200) {
                const list = response?.responseData?.data
                setPujaList(list);
                setTotalRecords(list?.length);
                setLoader(false);
            }
        } catch (error) {
            setLoader(false);
            console.log(error);
        }
    };

    // ----------------------------------Other Functions---------------------------------

    const viewDetail = (product) => {
        const newSlug = product?.pujaSlug;
        if (selectedCategory) {
            sessionStorage.setItem("selectedCatId", selectedCategory);
        }
        navigate(`/service/puja-details/${newSlug}`, {
            state: { puja: product },
        });
    };

    const handleCatChange = (category) => {
        setTotalRecords(-1)
        setPujaList([])
        setSelectedCategory(category.pujaCatKeyID);
        sessionStorage.setItem("selectedCatId", category?.pujaCatKeyID);
        GetPujaLookupListData(3, 5, category.pujaCatKeyID)
    };

    return (
        <>
            <Helmet>
                <title>
                    {metaTitle}
                </title>
                <meta property="og:url" content={window.location.href} />
                <meta property="og:type" content="website" />
                <meta
                    name="description"
                    content={metaDesc}
                />
                <link rel="canonical" href="https://www.myomnamo.com/pandit-puja" />
                <meta
                    property="og:title"
                    content={metaTitle}
                />
                <meta
                    property="og:description"
                    content={metaDesc}
                />
                <meta name="twitter:card" content="summary_large_image" />
                <meta
                    name="twitter:title"
                    content={metaTitle}
                />
                <meta
                    name="twitter:description"
                    content={metaDesc}
                />

            </Helmet>
            <section className="page-header" style={{ paddingBottom: '28px' }}>
                <div
                    className="page-header__bg horoscope-banner-responsive"
                    style={{ backgroundImage: `url(${HoroscopeBannerImg})` }}
                ></div>
                <div className="container" style={{ display: 'block' }}>
                    <h2 className="page-header__title bw-split-in-left">{t("Pandit Puja")}</h2>
                    <div className="d-flex justify-content-center">
                        <Breadcrumbs />
                    </div>
                </div>
            </section>
            <div className="container-fluid my-4">
                {/* -------- Mobile View: Horizontal Categories -------- */}
                <fieldset className="border rounded mb-3 d-block d-md-none">
                    <legend className="float-none w-auto px-2 fw-bold" style={{ fontSize: "14px" }}>
                        {t("categories")}
                    </legend>
                    <div className="d-block d-md-none">
                        <div
                            className="d-flex overflow-auto"
                            style={{
                                whiteSpace: "nowrap",
                                scrollbarWidth: "none", // Firefox hide scrollbar
                                borderBottom: "1px solid #ddd",
                                paddingBottom: "4px",
                                gap: "24px",
                            }}
                        >
                            {categories?.map((cat) => (
                                <div
                                    key={cat.pujaCategoryID}
                                    ref={(el) => (scrollRefs.current[cat.pujaCategoryID] = el)}
                                    onClick={() => {
                                        handleCatChange(cat);

                                        // scroll selected category to center
                                        const el = scrollRefs.current[cat.pujaCategoryID];
                                        if (el) {
                                            el.scrollIntoView({
                                                behavior: "smooth",
                                                inline: "center", // horizontal centering
                                                block: "nearest",
                                            });
                                        }
                                    }}
                                    style={{
                                        position: "relative",
                                        cursor: "pointer",
                                        textTransform: "uppercase",
                                        fontWeight: selectedCategory === cat.pujaCatKeyID ? "600" : "400",
                                        color: selectedCategory === cat.pujaCatKeyID ? "#991b3d" : "#000",
                                    }}
                                >
                                    <span style={{ cursor: "pointer", }}>{cat.pujaCategoryName}</span>

                                    {/* underline for active item */}
                                    <span
                                        style={{
                                            position: "absolute",
                                            left: 0,
                                            right: 0,
                                            bottom: "-4px",
                                            height: "2px",
                                            cursor: "pointer",
                                            backgroundColor: "#991b3d",
                                            transform:
                                                selectedCategory === cat.pujaCatKeyID ? "scaleX(1)" : "scaleX(0)",
                                            transformOrigin: "center",
                                            transition: "transform 0.25s ease",
                                        }}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>

                </fieldset>

                <div className="row">
                    {/* -------- Desktop Sidebar -------- */}
                    <aside className="col-md-3 d-none d-md-block " >
                        {/* <div>
                            <h4 className='px-3 pt-3' >{t("Puja Type")}</h4>
                        </div>
                        <hr style={{ margin: "0px" }} />
                        <div
                            className="px-3"
                            style={{ maxHeight: "80vh", overflowY: "auto", scrollbarWidth: "none" }}
                        >

                            <ul className="list-unstyled">
                                <li className="mb-2">
                                    <label className="d-flex align-items-center">
                                        <input
                                            type="checkbox"
                                            className="form-check-input me-2"
                                            checked={!isOnlineSelected}
                                            onChange={e => {
                                                setIsOnlineSelected(false)
                                                setPujaStatus(false)
                                            }}
                                        />

                                        Offline
                                    </label>
                                </li>

                                <li className="mb-2">
                                    <label className="d-flex align-items-center">
                                        <input
                                            type="checkbox"
                                            className="form-check-input me-2"
                                            checked={isOnlineSelected}
                                            onChange={e => {
                                                setIsOnlineSelected(true)
                                                setPujaStatus(true)
                                            }}
                                        />

                                        Online
                                    </label>
                                </li>
                            </ul>

                        </div> */}
                        <div className='hr-color'>
                            <h4 className='px-3 pt-3' >{t("Puja Category")}</h4>
                        </div>

                        <div
                            className=" p-3"
                            style={{ maxHeight: "50vh", overflowY: "auto", scrollbarWidth: "none" }}
                        >

                            <ul className="list-unstyled" style={{ cursor: 'pointer' }}>
                                {categories?.map((cat, i) => (
                                    <li key={cat.pujaCategoryID} className="mb-2" onClick={() => handleCatChange(cat)} style={{ cursor: 'pointer' }}>
                                        <label className={`form-check-label small ${selectedCategory === cat.pujaCatKeyID ? "activeText" : ''}`} style={{ cursor: 'pointer' }}>
                                            <i className="fa fa-angle-right me-2"></i>
                                            {cat.pujaCategoryName}
                                        </label>
                                    </li>
                                ))}
                            </ul>
                        </div>

                    </aside>



                    {/* -------- Puja Grid -------- */}
                    <main className="col-md-9 col-12" >
                        <div className="row g-2 mt-1 " style={{ maxHeight: "100vh", overflowY: "auto", scrollbarWidth: "none", justifyContent: 'left' }}>
                            {pujaList?.map((puja, index) => (
                                <div
                                    className="col-xl-4 col-lg-4 col-md-6 col-sm-6 mb-4 "

                                    onClick={() => viewDetail(puja)}
                                >
                                    <div

                                        className="card shadow-sm  rounded-3 h-100 border bolder-dark"
                                        style={{ cursor: "pointer", overflow: "hidden" }}

                                    >
                                        {/* Image Section */}
                                        <div className="position-relative">
                                            <img
                                                src={puja.pujaImageUrl || pandit}
                                                alt={puja.pujaName}
                                                className="card-img-top"
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = pandit;
                                                }}
                                                style={{
                                                    height: "175px",
                                                    objectFit: "fill",
                                                    borderTopLeftRadius: "12px",
                                                    borderTopRightRadius: "12px",
                                                }}
                                            />

                                            {/* Date Badge */}
                                            {/* <div
                                                className="position-absolute top-0 end-0 bg-white text-center shadow-sm"
                                                style={{
                                                    borderRadius: "0 0 6px 6px",
                                                    padding: "6px 10px",
                                                    fontSize: "12px",
                                                    fontWeight: "bold",
                                                    color: "#8f3246",
                                                }}
                                            >
                                                <div>{puja.DATE || "29"}</div>
                                                <div style={{ fontSize: "10px" }}>
                                                    {puja.MONTH || "AUG"}
                                                </div>
                                            </div> */}
                                        </div>

                                        {/* Card Body */}
                                        <div className="card-body p-2 d-flex flex-column">
                                            <h6
                                                className={`card-title fw-bold mb-1 ${selectedLanguageID == 3 ? "marathiHeader" : ""}`}
                                                style={{ color: "#8f3246", fontSize: "16px" }}
                                            >
                                                {puja.pujaName}
                                            </h6>

                                            {/* <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
                                                {puja.PUJA_TAGLINE || "A powerful ritual description..."}
                                            </p> */}



                                            {/* Price & Button */}
                                            <div className="mt-auto">
                                                <span
                                                    className="fw-bold"
                                                    style={{ fontSize: "16px", color: "#000" }}
                                                >
                                                    ₹
                                                    {
                                                        puja.onlinePujaPrice
                                                            ? formatToIndianCurrency(Math.round(puja.onlinePujaPrice - (puja.onlinePujaDiscountAmount || 0)))
                                                            : formatToIndianCurrency(Math.round(puja.offlinePujaPrice - (puja.offlinePujaDiscountAmount || 0)))
                                                    }
                                                </span>
                                                <button
                                                    className="btn w-100 mt-2"
                                                    style={{
                                                        backgroundColor: "#8f3246",
                                                        color: "#fff",
                                                        borderRadius: "8px",
                                                        textTransform: "none",
                                                    }}
                                                >
                                                    <span className="blink-text"
                                                        onClick={() => viewDetail(puja)}
                                                    >
                                                        {t("Book Puja Now")}
                                                    </span>
                                                </button>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {totalRecords <= 0 && <NoResultFoundModel totalRecords={totalRecords} />}
                        </div>
                    </main>
                </div>
            </div>


        </>
    )
}

export default PanditPujaListPage
